// hardcoded to EDS colors and using interactions rule on hsla since ~/ui will be refactored away.
export const EDS_ACTION_COLOR = 'hsl(220,160%,50%)';
const EDS_ACTION_ACTIVE_COLOR = 'hsl(220,160%,45%)';
const EDS_ACTION_ACTIVE_HOVER_COLOR = 'hsl(220,160%,40%)';
const EDS_ACTION_HOVER_COLOR = 'hsl(220,160%,47%)';

export const EDS_TEXT_PRIMARY = 'hsla(0, 0%, 10%, 1)';
const EDS_TEXT_SECONDARY = 'hsla(0, 0%, 40%, 1)';
export const ESD_TEXT_QUIET = 'hsla(0, 0%, 50%, 1)';
